import BenchmarkMetricChartInfo from './BenchmarkMetricChartInfo';

export default BenchmarkMetricChartInfo;

